import hoistNonReactStatics from 'hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js';

export default hoistNonReactStatics;
